import React from 'react';
import PropTypes from 'prop-types';
import { withSize } from 'react-sizeme';
// Core components
import Tooltip from 'components/core/Tooltip';

class TruncatedTooltipText extends React.Component {
  constructor(props) {
    super(props);

    // Create a ref for Tooltip inner component
    this.compRef = React.createRef();

    // Store current clientWidth
    this.currentClientWidth = 0;

    this.state = {
      displayTooltip: false,
    };

    // Async update handle to avoid nested update loops
    this._updateTooltipTimeout = null;
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.doCheckForTooltip();
  }

  componentDidUpdate() {
    this.doCheckForTooltip();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._updateTooltipTimeout) {
      clearTimeout(this._updateTooltipTimeout);
      this._updateTooltipTimeout = null;
    }
  }

  // Private
  doCheckForTooltip() {
    // Get cell node
    const { current } = this.compRef;
    if (!current) return;

    const newClientWidth = current.clientWidth;
    const newScrollWidth = current.scrollWidth;
    const nextDisplayTooltip = newScrollWidth > newClientWidth;

    const clientWidthChanged = this.currentClientWidth !== newClientWidth;

    // Always update cached width to keep measurements fresh
    if (clientWidthChanged) {
      this.currentClientWidth = newClientWidth;
    }

    // Only transition from false -> true to avoid flip-flop loops
    if (!this.state.displayTooltip && nextDisplayTooltip) {
      if (this._updateTooltipTimeout) {
        clearTimeout(this._updateTooltipTimeout);
        this._updateTooltipTimeout = null;
      }
      if (this._isMounted) {
        this._updateTooltipTimeout = setTimeout(() => {
          if (this._isMounted) {
            this.setState({ displayTooltip: true });
          }
        }, 0);
      }
    }
  }

  render() {
    const { children, textToDisplay } = this.props;
    const { displayTooltip } = this.state;

    if (children) {
      return (
        <Tooltip
          innerRef={this.compRef}
          content={displayTooltip ? (textToDisplay || children) : ''}
          inheritStyle={false}
          className="text-truncate"
        >
          { children }
        </Tooltip>
      );
    }
    return null;
  }
}

TruncatedTooltipText.propTypes = {
  children: PropTypes.node,
  textToDisplay: PropTypes.string,
};

TruncatedTooltipText.defaultProps = {
  children: null,
  textToDisplay: null,
};

// withSize is only used to trigger componentDidUpdate on component resize
export default withSize({ noPlaceholder: true, refreshRate: 500, refreshMode: 'debounce' })(TruncatedTooltipText);



// WEBPACK FOOTER //
// ./components/misc/TruncatedTooltipText.js